export default __webpack_public_path__ + "static/media/CEDIA-Aguaje.cd96aade.jpg";